import { render, staticRenderFns } from "./User.vue?vue&type=template&id=73968b0a&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
import style0 from "./User.vue?vue&type=style&index=0&id=73968b0a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73968b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73968b0a')) {
      api.createRecord('73968b0a', component.options)
    } else {
      api.reload('73968b0a', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=73968b0a&scoped=true", function () {
      api.rerender('73968b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User.vue"
export default component.exports